import React from "react";
import Main from "./Main";
import "./HomePage.css";

export default function HomePage() {
  return (
    <div className="typora-container">
      <Main />
    </div>
  );
}
